import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import SettingsPage from '@portal/features/settings/SettingsPage'
import { TextTitle } from '@portal/features/titles'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => (
  <>
    <Header.Left>
      <BackButton to="/dashboard" />
    </Header.Left>
    <Header.Center>
      <TextTitle title="Settings" />
    </Header.Center>
    <SettingsPage />
  </>
)

export const Route = createFileRoute('/_app/settings')({
  component: RouteComponent,
})
